import { render, staticRenderFns } from "./UpdateInfo1.vue?vue&type=template&id=62250d0f&scoped=true&"
import script from "./UpdateInfo1.vue?vue&type=script&lang=js&"
export * from "./UpdateInfo1.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfo1.vue?vue&type=style&index=0&id=62250d0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62250d0f",
  null
  
)

export default component.exports